import React from 'react';
import { Link } from 'react-router-dom';
import KajabiFormEmbed from './KajabiFormEmbed';

const Section_2 = ({ setShowVideo }) => {
  return (
    <div className="ace-slide w-full">
      <div className="ace-slider-center w-full">
        <div style={{ 
            backgroundImage: `url('/photo/slider-trial.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            borderRadius: '25px'
            
            // You can add more background properties as needed
          }}>
         
                <div className="w-full pt-[80px] pb-[80px] ace-container-form flex flex-row items-center justify-center flex-wrap" style={{ width: '100%', backgroundColor: 'rgb(11 13 42 / 92%)',  minHeight: '600px', }}>
                  <div className="">
                        <div className="headline">Try Quantum Flo Signals – Free for 30 Days</div>
                        <div className="subtext">
                          Get 2 weekly AI-powered trade alerts — straight from our fully automated trading engine.<br />
                          Plus: 2 custom TradingView indicators + daily market briefings.
                        </div>
                        <div className="flex flex-row ace-m-flex-col flex-wrap" style= {{ maxWidth:'800px', margin: '0 auto'}} >
                            <div className="ace-col50 ace-m-col100">
                                {/* Custom Form */}
                                <div className="form-here">
                                    <KajabiFormEmbed/>
                                </div>
                                <div className="disclaimer mt-6">No spam. No credit card. Cancel anytime.</div>
                            </div>   
                            <div className="ace-col50 ace-m-col100">
                                <div className="benefits2 mt-4 space-y-1">
                                  <div>✅ 2 AI-generated trade alerts per week</div>
                                  <div>✅ Daily insights with entry/exit levels</div>
                                  <div>✅ MSI + PAI TradingView indicators</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          
        </div>
      </div>
    </div>
  );
};

export default Section_2;